import type { ProductionPlanPreview } from "./plan-import-types";
import { formatDate, formatQuantity, formatClock, productStage, workOrderMatchLabel } from "./plan-import-presentation";
export function workOrderConnection(row: ProductionPlanPreview["rows"][number]) {
  if (row.workOrderMatch === "MISSING") return <>
    <strong className="is-warning">{productStage(row) === "BULK_SEMI_21_22" ? "Toplu Q iş emri eksik" : "İş emri eksik"}</strong>
    <small>Çizelgeye alınmayacak</small>
  </>;
  if (row.workOrderMatch === "AMBIGUOUS") return <>
    <strong className="is-warning">{productStage(row) === "BULK_SEMI_21_22" ? "Tek Q iş emri seçilemedi" : "Tek iş emri seçilemedi"}</strong>
    <small>{row.candidateWorkOrderNos?.join(", ") || "Aday bulunamadı"}</small>
  </>;
  const linkedDemands = row.linkedDemandWorkOrders ?? [];
  const scheduleSlots = row.scheduleSlots ?? [];
  return <>
    <strong>{row.workOrderNo ?? "—"}</strong>
    {workOrderMatchLabel(row) ? <small>{workOrderMatchLabel(row)}</small> : null}
    {row.workOrderMatch === "MIKRO_BULK_Q" ? <small>
      Bu hafta {linkedDemands.length} bağlı IHR · {formatQuantity(row.linkedDemandQuantity ?? 0, row.productUnit ?? "")}
      {(row.candidateWorkOrderNos?.length ?? 0) > 1 ? ` · ${row.candidateWorkOrderNos?.length} tarihsel etkin Q içinden son kullanılan` : ""}
    </small> : null}
    {linkedDemands.length > 0 ? <details className="production-plan-linked-demands">
      <summary>Bağlı müşteri ihtiyaçlarını göster</summary>
      <ul>{linkedDemands.map((demand) => <li key={demand.workOrderNo}>
        <span><b>{demand.workOrderNo}</b>{demand.parentWorkOrderNo ? ` → ${demand.parentWorkOrderNo}` : ""}</span>
        <span>{demand.parentOutputCode ?? "19’lu mamul bilinmiyor"}</span>
        <strong>{formatQuantity(demand.plannedQuantity, row.productUnit ?? "")}</strong>
      </li>)}</ul>
    </details> : null}
    {scheduleSlots.length > 0 ? <details className="production-plan-linked-demands production-plan-schedule-slots">
      <summary>{scheduleSlots.length} çizelge dilimini göster</summary>
      <ul>{scheduleSlots.map((slot) => <li key={`${slot.lineName}:${slot.startAt}`}>
        <span><b>{formatDate(slot.date)}</b> · {slot.shiftCode}</span>
        <span>{slot.lineName} · {formatClock(slot.startAt)}–{formatClock(slot.endAt)}</span>
        <strong>{formatQuantity(slot.quantity, row.productUnit ?? "")}</strong>
      </li>)}</ul>
    </details> : null}
  </>;
}
